import { Partner } from "./partner";

export class User {
    id!: number;
    created_at!: Date;
    updated_at!: Date;
    last_action!: Date;
    first_name!: string;
    last_name!: string;
    email!: string;
    mobile_phone!: string;
    type!: string;
    notes!: string;
    show_checkin_differences!: boolean;
    show_upcoming_no_employee!: boolean;
    show_latest_reserved!: boolean;
    show_new_orders!: boolean;
    show_new_customers!: boolean;
    show_new_applicants!: boolean;
    show_messages!: boolean;
    show_unhandled_feedback!: boolean;
    show_upcoming_birthdays!: boolean;
    show_upcoming_unprofitable!: boolean;
    show_message_template_warning!: boolean;
    show_holiday_warning!: boolean;
    show_tasks_needing_attention!: boolean
    show_tasks_not_completed!: boolean  
    show_key_warnings!: boolean
    email_new_customer!: boolean
    email_new_order!: boolean
    email_change_request!: boolean
    email_payment_failed!: boolean;
    lang!: string
    build!: string
    notification_new_customer!: boolean;
    notification_new_order!: boolean;
    notification_employee_cancelled!: boolean;
    notification_customer_cancelled!: boolean;
    notification_change_request!: boolean;
    notification_contact_from_customer!: boolean;
    notification_contact_from_employee!: boolean;
    notification_new_applicant!: boolean;
    notification_payment_failed!: boolean;
    free!: boolean
    partner!: Partner
    show_negative_balance_warnings!: boolean
    notification_payment_successful!: boolean
    email_payment_successful!: boolean
    show_upcoming_payer_missing!: boolean
    screen_name!: string
}
